<template>
  <div style="margin-top:5px;padding:10px;" class="card">
    {{ chosenMeetingName }}
    <div style="float:right">
      <b-tooltip :label="$t('meeting.projeter')" position="is-left">
        <div @click="projeterMeeting()">
          <img
            class="icon"
            src="@/assets/img/icons/camera-icon.png"
            alt="video-icon"
          />
        </div>
      </b-tooltip>
      <b-tooltip :label="$t('public.poser_question')" position="is-left">
        <div @click="poserQuestion()">
          <img
            class="icon"
            type="image/svg+xml"
            src="@/assets/img/icons/pen-icon1.svg"
            alt="pen-icon"
          />
        </div>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListTools",
  props: {
    urlModerateur: String,
    chosenMeetingName: String,
    urlParticipant: String
  },
  methods: {
    projeterMeeting() {
      if (this.$store.getters.iframeColidee) {
        this.$router.push("/projeter-" + this.urlParticipant + '/' + this.$store.state.langage.langue)
      } else {
        window.open("projeter-" + this.urlModerateur);
      }
    },
    scrollToTopParent() {
      let message = {
        task: "scrollToTop"
      };
      window.top.postMessage(message, "*");
    },
    poserQuestion(event) {
      this.scrollToTopParent();
      this.$store.dispatch("popupTogglePoserQuestion");
    }
  }
};
</script>

<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
  margin-left: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/animerPage/components/ListTools.vue